<template>
	<van-popup v-model="show" :position="isMobileFlag?'bottom':'center'" get-container="body" closeable
		class="bs-popup "   >
		<div class="bs-popup-head">
			<div class="bs-popup-tit">
				{{ $t('支付订单') }}
			</div>
		</div>
		<div class="bs-popup-scroll" >
			<div class="bs-popup-body">
				<div class="confirm-panel" v-if="userData">
					<div class="account-card" >
						<div class="account-label">{{ $t('账户余额') }}</div>
						<div class="account-value text-primary">{{formatNumber(userData.user_money)}}</div>
					</div>
					<div class="info-items" v-if="paramData">
						<div class="info-item">
							<span>{{$t('姓名')}}:</span>{{paramData.address_name}}
						</div>
						<div class="info-item">
							<span>{{$t('电话')}}:</span>{{paramData.address_phone}}
						</div>
						<div class="info-item">
							<span>{{$t('详细地址')}}:</span>{{paramData.address_details}}
						</div>
						<div class="info-item">
							<span>{{$t('订单金额')}}:</span>{{paramData.Amount}}
						</div>
					</div>
					<div class="confirm-panel_ft">
						<el-button round type="primary" class="btn-confirm" block @click="onSubmit">
							{{ $t('确认支付') }}
						</el-button>
					</div>
				</div>
			</div>
		</div>
	</van-popup>
</template>
<script>
	import helper from '@/common/helper.js';
	import {order_pay_api } from "@/api/user"
	export default {
		components: {},
		props: {
			payids: {
			    type: String,
			    default: ""
			},
			paramData: {
				type: Object,
				default: () => ({}) // 返回一个空对象
			}
		},
		data() {
			return {
				show: false,
				userData:null,
				countdown: 2
			};
		},
		methods: {
			open(){
				this.onSubmit()
			},
			async onSubmit() {
				console.log(this.payids,'this.payidsthis.payidsthis.payids')
				let data = {
					id: this.payids,
				}
				if(!this.$store.state.isLoginStatu){
					data["uuid"] = helper.get('uuid') || ''
				}
				console.log(data,'datadatadata')
				const loading = this.$loading({
				  lock: true,
				  text: '',
				  spinner: 'loader',
				  background: 'rgba(255, 255, 255, 0.3)'
				});
				await order_pay_api(data).then(res => {
					if (res && res.data.code == 1) {
						this.platUrl(res.data.data)
						this.show = false
						this.goUrl('/my-order')
						helper.rm('ConfirmProductData')
						loading.close()
					}else{
						this.errorTips(res.data.msg)
						loading.close()
					}
				});
			},
		},
		mounted() {
			if(helper.get("userInfo") != ""){
				this.userData = helper.get("userInfo")
			}
		}
	}
</script>
<style scoped>
	.confirm-panel{
		padding: 10px;
	}
	.confirm-panel_ft{
		margin-top: 80px;
		.btn-confirm{
			width: 100%;
		}
	}
	.info-items .info-item{
		padding: 10px 0;
	}
	.info-items .info-item span{
		color: #777;
	}
	
	
</style>